import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render () {
    const faqs = [
      { q: "❓ Это правда бесплатно? Не будет ли скрытых платежей?", a: "Да, это бесплатно навсегда. Вы не платите ни абонентскую плату, ни проценты с бронирований. Единственный возможный платеж — это комиссия банка за онлайн-оплату, если вы её подключите, и смс-информирование." },
      { q: "❓ Как клиенты смогут записаться ко мне?", a: "Мы бесплатно создадим для вас страницу с онлайн-записью и сгенерируем QR-код. Разместите его на стойке, или просто ссылку на сайте или в соцсетях — клиенты смогут записываться в 2 клика, 24/7. Вы также сможете записывать клиентов по телефону в нашем приложении или на нашем сайте для избежания двойных бронирований. Полный календарь будет всегда у вас под рукой." },
      { q: "❓ Нужно ли моим сотрудникам устанавливать приложение?", a: "Нет, достаточно браузера на телефоне. Каждый сотрудник видит своё расписание, может записывать к себе клиентов, получать уведомления, но в приложении больше возможностей" },
      { q: "❓ Как происходит оплата услуг через систему?", a: "Вы можете подключить онлайн-оплату через любой популярный банк. Мы не берём комиссию за платежи — вы платите только стандартный процент банку-эквайеру." }
    ];

    const businessTypes = [
      { name: "Салоны красоты, массаж, барбершопы", icon: "fas fa-cut", link: "/business/beauty", color: "#32bea6" },
      { name: "Рестораны, кафе, бары", icon: "fas fa-utensils", link: "/business/restaurant", color: "#32bea6" },
      { name: "Отели, апартаменты, квартиры", icon: "fas fa-hotel", link: "/business/hotel", color: "#32bea6" },
      { name: "Спортивные площадки", icon: "fas fa-futbol", link: "/business/sport", color: "#32bea6" },
      { name: "Прокат оборудования, инструментов, одежды", icon: "fas fa-tools", link: "/business/rent", color: "#32bea6" },
      { name: "Коворкинги", icon: "fas fa-couch", link: "/business/coworking", color: "#32bea6" },
      { name: "Мероприятия (концерты, конференции)", icon: "fas fa-ticket-alt", link: "/business/event", color: "#32bea6" },
      { name: "Автосервисы, шиномонтаж, автомойки", icon: "fas fa-car", link: "/business/auto", color: "#32bea6" },
      { name: "Фитнес-студии, йога-центры", icon: "fas fa-dumbbell", link: "/business/fitness", color: "#32bea6" },
      { name: "Частные мастера (массаж, репетиторы)", icon: "fas fa-user-check", link: "/business/master", color: "#32bea6" }
    ];

    const visualTypes = [
      { type: "Ресторан, кафе, бар", visual: "Схема зала с расстановкой столов" },
      { type: "Отель", visual: "Выбор конкретного номера на этаже" },
      { type: "Коворкинг", visual: "План с рабочими местами и переговорными" },
      { type: "Аренда оборудования / одежды / авто", visual: "Каталог с фотографиями каждой единицы" },
      { type: "Мероприятия", visual: "Выбор места в зале" }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Бесплатная система онлайн-записи и CRM для бизнеса | Planna</title>
          <meta name="description" content="Автоматизируйте запись клиентов без абонентской платы. Бесплатная CRM, онлайн-бронирование, расписание и QR-код для стенда. Для салонов, аренды, студий." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>
        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">⚡ Бесплатная CRM и онлайн-запись для бизнеса | Замена тетради и телефона</div>
            <h1>Бесплатная CRM-система и онлайн-запись <span className="highlight">для вашего бизнеса</span></h1>
            <p className="hero-description">Откройте мир, где ваши услуги находят клиентов, а администрация работает на автопилоте. Бесплатно — навсегда. Никаких абонентских плат, скрытых комиссий или процентов за бронирование.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить бизнес бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Привлекайте клиентов */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Привлекайте клиентов, которые уже готовы к бронированию</h2>
              <p className="section-subtitle">Ваш бизнес становится частью их планов</p>
            </div>
            <div className="grid-3 fade-up">
              <a key="1" href="/business/beauty" style={{ textDecoration: 'none' }}>
                <div className="benefit-card" style={{ textAlign: 'center' }}>
                  <i className="fas fa-hotel benefit-icon"></i>
                  <h3>Отели и салоны красоты</h3>
                  <p>Клиенты выбирают из тысяч вариантов и бронируют у вас.</p>
                </div>
              </a>
              <a key="2" href="/business/rent" style={{ textDecoration: 'none' }}>
                <div className="benefit-card" style={{ textAlign: 'center' }}>
                  <i className="fas fa-tools benefit-icon"></i>
                  <h3>Аренда чего угодно</h3>
                  <p>От дизайнерской одежды до строительного оборудования – находите временных владельцев.</p>
                </div>
              </a>
              <a key="3" href="/business/restaurant" style={{ textDecoration: 'none' }}>
                <div className="benefit-card" style={{ textAlign: 'center' }}>
                  <i className="fas fa-chair benefit-icon"></i>
                  <h3>Рестораны</h3>
                  <p>Интерактивная схема зала: клиенты сами выбирают столик у окна, сцены или в тихой зоне.</p>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Единое пространство времени */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Единое пространство для бизнеса и жизни</h2>
              <p className="section-subtitle">Забудьте о двойных бронированиях и путанице</p>
            </div>
            <div className="smart-block fade-up" style={{ background: 'white' }}>
                <div style={{ flex: 1 }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '3rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.6rem', fontWeight: '700' }}>Календарь сотрудника = рабочий + личный</h3>
                  <p style={{ marginTop: '1rem', minWidth: "16rem" }}>Если парикмахер записался к стоматологу через наш сервис, его рабочее расписание автоматически обновится – это время блокируется для записи клиентов. Никаких конфликтов, никакого ручного согласования.</p>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="screenshot-placeholder">
                    <img src="{{mainApiUrl}}combined1.png" alt="Единый календарь" />
                    <div className="mockup-label">🔄 Рабочие и личные дела – вместе</div>
                  </div>
                </div>
            </div>
          </div>
        </section>

        {/* Визуальный выбор */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Визуальный выбор во всех деталях</h2>
              <p className="section-subtitle">Наша система позволяет создать интерактивные схемы и каталоги для любого бизнеса</p>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', margin: '1rem 0' }}>
                <thead>
                  <tr style={{ background: 'rgba(50,190,166,0.1)', borderBottom: '2px solid #32bea6' }}>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Тип бизнеса</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Что можно визуализировать</th>
                  </tr>
                </thead>
                <tbody>
                  {visualTypes.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                      <td style={{ padding: '12px' }}><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> {item.type}</td>
                      <td style={{ padding: '12px' }}>{item.visual}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="grid-2 fade-up" style={{ marginTop: '2rem' }}>
              <div className="benefit-card">
                <i className="fas fa-upload benefit-icon"></i>
                <h3>Как это работает</h3>
                <p>1. Вы загружаете схему или фотографии через простой интерфейс.<br />2. Настраиваете зоны, цены, правила бронирования.<br />3. Система автоматически отображает доступность в реальном времени.<br />4. Клиенты выбирают и бронируют — всё визуально и понятно.</p>
              </div>
              <div className="benefit-card">
                <i className="fas fa-gift benefit-icon"></i>
                <h3>Что вы получаете бесплатно навсегда?</h3>
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Интеллектуальное расписание с учётом личных планов команды</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Снижение административной нагрузки</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Все бронирования в одном месте (смартфон, планшет, ПК)</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Полная история ресурсов (оборудование, сотрудники)</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Собственная страница компании с QR-кодом для стенда</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6', marginRight: '8px' }}></i> Отчёты о загрузке, рейтинг добросовестности клиентов</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Для кого система */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Для кого создана эта система?</h2>
            <div className="stats-grid" style={{ justifyContent: 'center', gap: '1.2rem', marginTop: '2rem' }}>
              {businessTypes.slice(0,5).map((biz, idx) => (
                <a key={idx} href={biz.link} style={{ textDecoration: 'none' }}>
                  <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '180px', cursor: 'pointer', transition: '0.2s' }}>
                    <i className={`${biz.icon} benefit-icon`} style={{ color: biz.color }}></i>
                    <h3 style={{ fontSize: '1rem', color: '#000' }}>{biz.name}</h3>
                  </div>
                </a>
              ))}
            </div>
            <div className="stats-grid" style={{ justifyContent: 'center', gap: '1.2rem', marginTop: '1rem' }}>
              {businessTypes.slice(5).map((biz, idx) => (
                <a key={idx} href={biz.link} style={{ textDecoration: 'none' }}>
                  <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '180px', cursor: 'pointer', transition: '0.2s' }}>
                    <i className={`${biz.icon} benefit-icon`} style={{ color: biz.color }}></i>
                    <h3 style={{ fontSize: '1rem', color: '#000' }}>{biz.name}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white' }}>
              <div style={{ flex: 1 }}>
                <div className="screenshot-placeholder">
                  <img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" />
                  <div className="mockup-label">📱 Управляйте бизнесом со смартфона</div>
                </div>
              </div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Ваши сотрудники и гости могут пользоваться сервисом через удобные нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для бизнеса:</strong> записывайте клиентов используя личную телефонную книгу, принимайте бронирования, управляйте схемами, получайте уведомления — всё с телефона</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для клиентов:</strong> онлайн-запись, бронирование в один клик, календарь</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Кроссплатформенность — работайте где угодно</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* Как это работает за 5 минут */}
        {/*
        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <div className="grid-3" style={{ marginTop: '2rem' }}>
              <div className="benefit-card"><i className="fas fa-user-plus benefit-icon"></i><h3>1. Регистрация</h3><p>Создайте аккаунт за 1 минуту.</p></div>
              <div className="benefit-card"><i className="fas fa-user-plus benefit-icon"></i><h3>1. Зарегистрировать компанию</h3><p>Создайте аккаунт для бизнеса за 1 минуту.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>2. Получите QR-код</h3><p>Мы сгенерируем ссылку и QR-код для вашей страницы бронирования.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>3. Принимайте заявки 24/7</h3><p>Клиенты записываются онлайн, вы управляете расписанием.</p></div>
            </div>
          </div>
        </section>
        */}
        {/*
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (объекты аренды)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
        */}

        {/* FAQ */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Часто задаваемые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>
                    {faq.q} <i className="fas fa-chevron-down"></i>
                  </div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Станьте частью экосистемы, где технологии работают на гармонию вашего бизнеса и жизни вашей команды</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Бесплатно навсегда. Никакой абонентской платы.</p>
            <a href="/configcompany" className="btn-filled" style={{ background: 'white', color: '#1F2937', boxShadow: 'none' }}>Подключить бизнес бесплатно <i className="fas fa-arrow-right"></i></a>
          </div>
        </section>
      </div>
    );
  }
}
